"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  init: true,
  setCity: true,
  setTimezone: true
};
exports.init = init;
exports.setCity = setCity;
exports.setTimezone = setTimezone;

var _base = require("./base");

var _interface = require("./interface");

Object.keys(_interface).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _interface[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _interface[key];
    }
  });
});

var _inited;

function init(config) {
  if (_inited) return new Promise(function (resolve) {
    return resolve();
  });

  if (config) {
    return (0, _base.initBase)([config.cityMap, config.countryTimezone, config.timezone]).then(function () {
      _inited = true;
    });
  } else {
    return Promise.all([fetch("https://static.didiglobal.com/ibt/elvish/cityMap.json").then(function (res) {
      return res.json();
    }), fetch("https://static.didiglobal.com/ibt/elvish/countryTimezone.json").then(function (res) {
      return res.json();
    }), fetch("https://static.didiglobal.com/ibt/elvish/timezone.json").then(function (res) {
      return res.json();
    })]).then(_base.initBase).then(function () {
      _inited = true;
    });
  }
}

function setCity(cityId) {
  (0, _base.initCity)(cityId);
}

function setTimezone(timezone) {
  (0, _base.initTimezone)(timezone);
}